export const generateStatusStyle = (status) => {

  const bgLightColor = (status) => {
    return status === "Processing"
      ? "#efefef"
      : status === "Delivered"
      ? "#eaf9ef"
      : status === "Shipped"
      ? "#ecdcf8"
      : status === "Warning"
      ? "#fcebd1"
      : "#fceddd";
  };

  const bgColor = (status) => {
    return status === "Processing"
      ? "#a2a2a2"
      : status === "Delivered"
      ? "#10d005"
      : status === "Shipped"
      ? "#4b0ace"
      : "#f8aa27";
  };

  const textColor = (status) => {
    return status === "Processing"
      ? "#a2a2a2"
      : status === "Delivered"
      ? "#b4dbae"
      : status === "Shipped"
      ? "#4b0ace"
      : "#f8aa27";
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div
        style={{
          background: bgLightColor(status),
          padding: "3px",
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          marginRight: "10px",
          display: "grid",
          placeItems: "center",
        }}
      >
        <div
          style={{
            background: bgColor(status),
            padding: "5px",
            borderRadius: "50%",
            //   width:"17px",
            //   height:"17px"
          }}
        ></div>
      </div>
      <strong style={{ color: textColor(status) }}>
        {status || "Unavailable"}
      </strong>
    </div>
  );
};
